import { Box, CircularProgress, Drawer, Typography } from '@mui/material';
import { useGetItemsQuery } from '../slices/simpleApiSlice';

// маленький вспомогательный компаратор
function compare(a, b, op) {
  switch (op) {
    case '===':
      return a === b;
    case '!==':
      return a !== b;
    case '>':
      return a > b;
    case '>=':
      return a >= b;
    case '<':
      return a < b;
    case '<=':
      return a <= b;
    default:
      return false;
  }
}

const AddDrawer = (props) => {
  const queryParams = {};
  const {
    open,
    onClose,
    addSlug,
    filter = [],
    existingIds,
    onSelect,
    title = 'Выберите элемент',
    titleKey,
    id,
  } = props;

  filter.forEach((f) => {
    // 1. Простой фильтр без условия
    if (!f.when) {
      queryParams[f.field] = f.value;
      return;
    }

    // 2. Условный фильтр
    // Проверяем, что нужное поле вообще существует в props
    if (!(f.when.prop in props)) {
      console.warn(
        `Условный фильтр требует пропс "${f.when.prop}", но он не передан`,
      );
      return;
    }

    const propValue = props[f.when.prop];

    // Защита от undefined / null, если это важно в твоём случае
    if (propValue === undefined || propValue === null) {
      return; // или можно решить по-другому: пропустить / кинуть ошибку
    }

    const shouldInclude = compare(
      propValue,
      f.when.value,
      f.when.operator || '===',
    );

    if (shouldInclude) {
      queryParams[f.field] = f.value;
    }
  });

  // ✅ Только внутри Drawer!
  const payload = {
    url: `/api/directories/${addSlug}`,
    params: { ...queryParams },
  };
  // console.log('AddDrawer query payload', payload);

  const { data: itemsData, isFetching } = useGetItemsQuery(payload, {
    skip: !open || !addSlug,
  });

  const items = itemsData?.rows || [];

  let availableItems;
  if (Array.isArray(existingIds)) {
    availableItems = items.filter((item) => !existingIds.includes(item._id));
  } else {
    availableItems = items;
  }

  const handleSelect = (item) => {
    onSelect(item); // ✅ Только передает выбор!
    onClose();
  };

  //   const handleSelect = async (itemId) => {
  //     try {
  //       await createLink({
  //         url: `/api/directories/${configSlug}`,
  //         data: {
  //           type: ownerId,
  //           stage: itemId,
  //           order: 999, // В конец
  //         },
  //       }).unwrap();

  //       onAddSuccess?.();
  //       onClose();
  //     } catch (error) {
  //       console.error('Add failed:', error);
  //     }
  //   };

  //   // ✅ Обработчик выбора!
  //   const handleItemSelect = async (selectedItem) => {
  //     try {
  //       await createLink({
  //         url: `/api/directories/${configSlug}`,
  //         data: {
  //           [config.localField || 'type']: ownerId, // type или owner
  //           [config.foreignField || 'stage']: selectedItem._id, // stage или другое
  //           order: 999,
  //         },
  //       }).unwrap();

  //       onAddSuccess?.(); // Обновить родительский список
  //       onClose();
  //     } catch (error) {
  //       console.error('Добавление не удалось:', error);
  //     }
  //   };

  // console.log('titleKey', titleKey);

  return (
    <Drawer
      anchor='right'
      open={open}
      onClose={onClose}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 10, // 1300 + 10 = 1310
        // или жёстко:
        // zIndex: 1400,
      }}
      // hideBackdrop // ← отключает фон Drawer'а
      ModalProps={{
        keepMounted: true, // опционально, если часто открывается/закрывается
      }}
    >
      <Box sx={{ width: 320, p: 2 }}>
        <Typography variant='h6' gutterBottom sx={{ mb: 3 }}>
          {title}
        </Typography>

        {isFetching ? (
          <CircularProgress />
        ) : availableItems.length ? (
          <Box
          //   sx={{ maxHeight: 400, overflow: 'auto' }}
          >
            {availableItems.map((item) => (
              <Box
                key={item._id}
                onClick={() => handleSelect(item)}
                sx={{
                  p: 1,
                  borderRadius: 1,
                  border: 1,
                  borderColor: 'divider',
                  mb: 1,
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  '&:hover': {
                    bgcolor: 'action.hover',
                    transform: 'translateX(4px)',
                  },
                }}
              >
                <Typography
                  variant='body1'
                  //  fontWeight={500}
                >
                  {item.title || item[titleKey]}
                </Typography>
                {/* {item.shortName && (
                  <Typography variant='body2' color='text.secondary'>
                    {item.shortName}
                  </Typography>
                )} */}
              </Box>
            ))}
          </Box>
        ) : (
          <Typography color='text.secondary' p={4} textAlign='center'>
            Все этапы уже добавлены
          </Typography>
        )}
      </Box>
    </Drawer>
  );
};

export default AddDrawer;
